export default __webpack_public_path__ + "static/media/ebay.5d99e609.svg";